import EntityUpdateView, { EntityUpdateViewProps } from './EntityUpdateView';

export default EntityUpdateView;
export type { EntityUpdateViewProps };
